import { Controller } from "@hotwired/stimulus"

// Profile Wizard controller for taste profile creation
export default class extends Controller {
  connect() {
    console.log("Profile wizard controller connected")
  }

  // Optional: Add validation or step navigation if needed
  // For now, the form is simple enough to submit directly
}
